export default __webpack_public_path__ + "static/media/11.152c093e.gif";